import { ClientApplicationStatus } from 'api/models/ClientApplicationStatus';
import { caseStatusOptions } from 'data/constants/caseStatus';
import type { BillingInstallment, ServiceCountryCode } from 'types';

export const BILLABLE_CASE_STATUSES: ClientApplicationStatus[] = caseStatusOptions
    .map((option) => option.value as ClientApplicationStatus)
    .filter((status) => status !== ClientApplicationStatus.REMOVED);

export const CASE_CREATED_STATUS = ClientApplicationStatus.NOT_ASSIGNED;

export const BILLING_COUNTRIES: { code: ServiceCountryCode; labelKey: string; currency: string }[] =
    [
        { code: 'CA', labelKey: 'canada', currency: 'CAD' },
        { code: 'AU', labelKey: 'australia', currency: 'AUD' },
        { code: 'UK', labelKey: 'unitedKingdom', currency: 'GBP' },
    ];

export const DEFAULT_BILLING_INSTALLMENTS: BillingInstallment[] = [
    { statuses: [CASE_CREATED_STATUS], percentage: 20 },
    {
        statuses: [ClientApplicationStatus.AWAITING_ITA, ClientApplicationStatus.SUBMITTED],
        percentage: 80,
    },
];
